/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBracketsOff = createReactComponent("outline", "brackets-off", "IconBracketsOff", [["path", { "d": "M5 5v15h3", "key": "svg-0" }], ["path", { "d": "M16 4h3v11m0 4v1h-3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconBracketsOff as default };
//# sourceMappingURL=IconBracketsOff.mjs.map
